import styled from 'styled-components';

export const RowActionsContainer = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
`;

export const RowActionLink = styled.a`
  font-size: 1.35rem;
  color: #000;
  display: flex;
`;

export const RowActionButton = styled.button`
  background-color: transparent;
  border: none;
  font-size: 1.35rem;
  color: #000;
  display: flex;
  cursor: pointer;
`;

export const TableToolbarContainer = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
`;

export const TableTitle = styled.p`
  font-size: 1.25rem;
  font-weight: 600;
  margin: 0;
`;

export const NewTemplateSurveyAction = styled.button`
  background-color: transparent;
  border: 1px solid #000;
  color: #000;
  padding: 0.25rem 0.75rem;
  border-radius: 0.25rem;
  font-size: 0.9rem;
  font-weight: 500;
  transition: all 0.2s;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 0.5rem;

  &:hover {
    color: #000;
    transform: scale(0.98);
  }
  
  &:link {
    color: #000;
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
`;